import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, ProgramIcon } from "./shared";
import { PROGRAMS } from "../../lib/data";

export const Programs = () => (
  <section className="section alt" id="programs" data-testid="programs-section">
    <div className="container">
      <Reveal><p className="eyebrow">Our Programs</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="section-title" style={{ marginTop: 16 }}>Six disciplines. <span className="accent">One standard.</span></h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="section-sub">Every program is coached to the same standard of precision and care — pick your path, or train them all.</p>
      </Reveal>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 26, marginTop: 56 }} className="programs-grid">
        {PROGRAMS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 0.08} y={50}>
            <Link to={`/programs/${p.slug}`} className="program-card" data-testid={`program-card-${i}`}
              style={{ textAlign: "left", width: "100%", display: "block" }}>
              <span className="program-num">{String(i + 1).padStart(2, "0")}</span>
              <div className="program-icon"><ProgramIcon name={p.icon} /></div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
              <span className="program-tag">Explore {p.title} <ArrowRight size={13} /></span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
